/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Refresh_GamepadsInputs */



/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Options_Pedal_Refresh_GamepadsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_refresh_gamepads = /** @type {((inputs?: Options_Pedal_Refresh_GamepadsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Refresh_GamepadsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refresh")
	if (locale === "de") return /** @type {LocalizedString} */ ("Refresh")
	if (locale === "it") return /** @type {LocalizedString} */ ("Refresh")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Refresh")
	if (locale === "es") return /** @type {LocalizedString} */ ("Refresh")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Refresh")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Refresh")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Refresh")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Refresh")
	return /** @type {LocalizedString} */ ("Refresh")
});